export default {
  "nav.events": "Events",
  "nav.gallery": "Gallery",
  "nav.contact": "Contact",

  "hero.benefit": "3 Rooms • 10 DJs • 1 All-Access Ticket",
  "hero.getTickets": "Get Tickets",
  "hero.soldOut": "Sold Out",

  "land.saveDate": "Save the date",
  "land.upcomingA": "Upcoming",
  "land.upcomingB": "Events",
  "land.festival": "Festival",
  "land.getTicketsArrow": "Get Tickets →",

  "home.watchEyebrow": "Aftermovies & recaps",
  "home.watchA": "Watch the",
  "home.watchB": "Takeover",
  "home.stagesEyebrow": "One ticket, three worlds",
  "home.stagesA": "Explore",
  "home.stagesB": "3 Stages",
  "stage.seoul.name": "Seoul Floor",
  "stage.seoul.desc": "Powered by SeoulVibes",
  "stage.seoul.floor": "7th Floor",
  "stage.main.name": "Mainstream Floor",
  "stage.main.desc": "Classic DUPLEX experience",
  "stage.main.floor": "6th Floor",
  "stage.saigon.name": "Saigon Floor",
  "stage.saigon.desc": "Powered by GANGSHII",
  "stage.saigon.floor": "5th Floor",
  "home.lineupEyebrow": "Lineup",
  "home.whoA": "Who plays",
  "home.whoB": "— and when?",
  "home.insideEyebrow": "From the sky",
  "home.insideA": "Inside",
  "home.insideB": "Duplex",
  "home.ctaA": "Ready for the",
  "home.ctaB": "Takeover?",
  "home.buyTickets": "Buy Tickets",

  "footer.tagline": "Prague's biggest Asian festival experience. Three rooms, one ticket, unforgettable nights.",
  "footer.quickLinks": "Quick Links",
  "footer.faq": "FAQ",
  "footer.terms": "Terms & Conditions",
  "footer.privacy": "Privacy Policy",
  "footer.refund": "Refund Policy",
  "footer.followUs": "Follow Us",
  "footer.rights": "© 2026 ASIA TAKEOVER. All rights reserved.",
  "footer.doorStaff": "Door Staff",
  "footer.admin": "Admin",

  "cookies.title": "Cookies",
  "cookies.text": "We use necessary cookies to run the site and process your order. With your permission we also use analytics and marketing cookies (Meta Pixel) to measure how our ads perform. You can refuse optional cookies and still buy tickets.",
  "cookies.necessary": "Necessary (always on)",
  "cookies.analytics": "Analytics",
  "cookies.marketing": "Marketing / Meta Pixel",
  "cookies.acceptAll": "Accept all",
  "cookies.customize": "Customize",
  "cookies.save": "Save selection",
  "cookies.reject": "Reject optional",

  "tickets.eyebrow": "Tickets",
  "tickets.standard": "Standard Ticket",
  "tickets.group": "Group of 4",
  "tickets.vip": "VIP Table Ticket",
  "tickets.nextRelease": "Next release:",
  "tickets.finalRelease": "Final online ticket release",
  "tickets.soldOut": "Sold out",
  "tickets.buy": "Buy Ticket",
  "tickets.buyGroup": "Buy Group Ticket",
  "tickets.groupPerPerson": "4 × Standard Ticket · {price} per person",
  "tickets.limitedCapacity": "Limited capacity",
  "tickets.reserve": "Reserve a Table",
  "tickets.vipRequired": "VIP Table Ticket required",
  "tickets.wantTable": "Want to book a table with bottle service? A VIP Table Ticket is required.",
  "tickets.noRefund": "Tickets are non-refundable · full refund only if the event is cancelled by the organizer",
  "tickets.swipe": "Swipe for more",
  "tickets.priceProgression": "Price increases as each release sells out",
  "tickets.loading": "Loading tickets…",
  "tickets.unavailable": "Tickets unavailable right now",
  "perks.std1": "Access to all 3 stages",
  "perks.std2": "Standing and dance floor access",
  "perks.std3": "Access to all public bars and rooftops",
  "perks.no1": "No access to VIP table areas",
  "perks.no2": "No reserved table or guaranteed seating",
  "perks.no3": "No bottle service",
  "perks.vip1": "Surprise gift ❤️‍🔥🎈 (value 200 Kč)",
  "perks.vip2": "Access to VIP areas on the Seoul Floor (7th) and Saigon Floor (5th).",
  "tickets.gold": "VIP Gold Table",
  "tickets.goldBadge": "Only 3 tables available",
  "tickets.goldFee": "3999 Kč table fee + 899 Kč per person",
  "perks.gold1": "Table close to the stage",
  "perks.gold2": "Entry to all 3 stages",
  "perks.gold3": "Access to VIP areas on the Seoul Floor (7th) and Saigon Floor (5th)",
  "perks.gold4": "Priority entry, VIP toilets and hostess service",
  "perks.gold5": "1 surprise gift per guest",
  "perks.gold6": "Bottle service available separately",
  "tickets.buyGold": "Buy Gold Table",
  "checkout.guestsGold": "Guests (4–14)",
  "checkout.guestsWord": "guests",
  "hero.upgrade": "Upgrade to VIP",
  "upgrade.title": "Upgrade to VIP",
  "upgrade.subtitle": "Already have a Standard ticket? Turn it into a VIP Table Ticket for 400 Kč.",
  "upgrade.codeLabel": "Your ticket code",
  "upgrade.codePlaceholder": "ATF-XXXXXX",
  "upgrade.verify": "Verify ticket",
  "upgrade.found": "Ticket found",
  "upgrade.priceLine": "Upgrade price",
  "upgrade.sameQr": "Your QR code stays the same — after payment it simply scans as VIP.",
  "upgrade.pay": "Pay upgrade",
  "upgrade.processing": "Creating payment…",
  "success.upgradeNote": "Your ticket is now VIP — keep using your original QR code.",
  "perks.vip3": "Ability to reserve a VIP table with bottle service",
  "perks.vip4": "Hostess service with your table reservation",
  "perks.vip5": "Access to the VIP balcony on the 7th floor",
  "perks.vip6": "Priority entry",
  "perks.vip7": "VIP toilets",

  "checkout.secure": "Secure checkout",
  "checkout.fullName": "Full name",
  "checkout.namePlaceholder": "Your name",
  "checkout.email": "Email",
  "checkout.phone": "Phone",
  "checkout.quantity": "Quantity",
  "checkout.ticketOne": "ticket",
  "checkout.ticketMany": "tickets",
  "checkout.groupNote": "1 group = 4 tickets",
  "checkout.discountCode": "Discount code",
  "checkout.enterCode": "Enter code",
  "checkout.apply": "Apply",
  "checkout.codeApplied": "Code {code} applied: −{percent}% (list price {price})",
  "checkout.continueToPayment": "Continue to Payment",
  "checkout.secureNote": "Secure card payment by Teya, directly on this page. Tickets are issued only after the payment is confirmed.",
  "checkout.termsNoteA": "By continuing you agree to our",
  "checkout.termsNoteB": "Terms & Conditions",
  "checkout.termsNoteC": ". Tickets are non-refundable and freely transferable.",
  "checkout.creating": "Creating your order…",
  "checkout.securePayment": "Secure payment",
  "checkout.groupTickets": "1 group (4 tickets)",
  "checkout.teyaNote": "Payments are processed by Teya. Tickets with QR codes arrive by email right after the payment is confirmed.",
  "checkout.promoApplyFirst": "Click Apply to activate your discount code before paying.",

  "success.confirming": "Confirming your payment…",
  "success.confirmingText": "We're verifying your payment with the payment gateway. This page updates automatically — no need to refresh.",
  "success.slowNote": "It's taking a bit longer than usual — your payment is still being confirmed. Once it's done, your tickets appear here and we also send them to your email. You can safely keep this page open.",
  "success.confirmed": "Payment confirmed",
  "success.youreIn": "You're in!",
  "success.orderLine": "Order {order} · {tier} × {qty} · {amount} · Screenshot your tickets and show the QR code at the entrance.",
  "success.loadingTickets": "Loading your tickets…",
  "success.notCompleted": "Payment not completed",
  "success.cancelled": "The payment was cancelled.",
  "success.expired": "The payment session expired.",
  "success.failed": "The payment failed.",
  "success.noCharge": "No tickets were issued and you have not been charged.",
  "success.backToTickets": "Back to Tickets",
  "success.refunded": "Order refunded",
  "success.refundedText": "This order has been {how} refunded.",
  "success.fully": "fully",
  "success.partially": "partially",
  "success.notFound": "Order not found",
  "success.notFoundText": "We couldn't find this order. If you just paid, wait a moment and check again.",
  "success.backHome": "← Back home",

  "reserve.eyebrow": "VIP Table Ticket",
  "reserve.titleA": "Reserve a",
  "reserve.titleB": "Table",
  "reserve.intro": "Tell us what you need — we will get back to you with table options and bottle service details.",
  "reserve.received": "Request received",
  "reserve.receivedText": "We will contact you shortly to arrange your VIP table. See you on 27.09. at DUPLEX.",
  "reserve.back": "← Back to tickets",
  "reserve.fullName": "Full name",
  "reserve.phone": "Phone number",
  "reserve.email": "Email",
  "reserve.guests": "Guests",
  "reserve.floor": "Preferred floor",
  "reserve.message": "Message (optional)",
  "reserve.messagePlaceholder": "Occasion, budget, bottle preferences…",
  "reserve.send": "Send Request",
  "reserve.sending": "Sending…",

  "contact.eyebrow": "Contact",
  "contact.title": "Get in touch",
  "contact.email": "Email",
  "contact.instagram": "Instagram",
  "contact.venue": "Venue",
  "contact.note": "For VIP tables, partnerships and press, email us and we'll get back to you within 48 hours.",

  "gallery.eyebrow": "Gallery",
  "gallery.titleA": "The",
  "gallery.titleB": "Map",
  "gallery.rooms": "KPOP Room • Mainstream Room • Saigon Room",
};
